import { Drawer, DrawerProps } from 'antd'
import { Feature, GeoJsonProperties, Geometry, Polygon } from 'geojson'
import React, { FunctionComponent, useCallback, useMemo } from 'react'

import { PROPERTY_TYPES } from '../../../common/drmTypes'
import { DRAWER_VIEW, resetPropertyDrawer } from '../../../redux/drawerSlice'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { propertyDrawerWrapperStyle } from '../../utils/layoutConst'
import { CadastreMapDetailDrawerFetchError } from '../CadastreMapDetailDrawerFetchError/CadastreMapDetailDrawerFetchError'
import { DetailDrawerArea } from '../DetailDrawerArea/DetailDrawerArea'
import { DetailDrawerBuilding } from '../DetailDrawerBuilding/DetailDrawerBuilding'
import { DetailDrawerPropertyHeader } from '../DetailDrawerPropertyHeader/DetailDrawerPropertyHeader'

export interface CadastreMapDetailDrawerProps {
  open: boolean
  onClose: NonNullable<DrawerProps['onClose']>
  features?: Feature<Geometry, GeoJsonProperties>[]
}

const assignmentModeStyle = {
  styles: {
    wrapper: {
      maxWidth: '75%',
      width: '400px',
      right: '390px',
    },
  },
}

export const CadastreMapDetailDrawer: FunctionComponent<CadastreMapDetailDrawerProps> =
  ({ open, onClose, features }) => {
    const dispatch = useAppDispatch()

    const isAssigmentMode =
      useAppSelector(state => state.drawer?.viewType) ===
      DRAWER_VIEW.ASSIGNMENT_MODE

    const cuzkData = useMemo(
      () => features?.[0] as Feature<Polygon | null, GeoJsonProperties>,
      [features]
    )

    const propertyType = useMemo(() => {
      if (cuzkData?.properties?.layerName === 'Parcela')
        return PROPERTY_TYPES.AREA
      if (cuzkData?.properties?.layerName === 'StavebniObjekt')
        return PROPERTY_TYPES.BUILDING
      return null
    }, [cuzkData])

    const handleOnClose = useCallback(
      (e: React.MouseEvent | React.KeyboardEvent) => {
        dispatch(resetPropertyDrawer())
        onClose(e)
      },
      [dispatch, onClose]
    )

    return (
      <Drawer
        title={<DetailDrawerPropertyHeader />}
        open={open}
        onClose={handleOnClose}
        destroyOnClose={true}
        {...(isAssigmentMode
          ? assignmentModeStyle
          : propertyDrawerWrapperStyle)}
      >
        {propertyType === PROPERTY_TYPES.AREA ? (
          <DetailDrawerArea cuzkData={cuzkData} />
        ) : propertyType === PROPERTY_TYPES.BUILDING ? (
          <DetailDrawerBuilding cuzkData={cuzkData} />
        ) : (
          <CadastreMapDetailDrawerFetchError />
        )}
      </Drawer>
    )
  }
